import { render, staticRenderFns } from "./wrapper.vue?vue&type=template&id=5c2a8a70"
import script from "./wrapper.vue?vue&type=script&lang=js"
export * from "./wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c2a8a70')) {
      api.createRecord('5c2a8a70', component.options)
    } else {
      api.reload('5c2a8a70', component.options)
    }
    module.hot.accept("./wrapper.vue?vue&type=template&id=5c2a8a70", function () {
      api.rerender('5c2a8a70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/filter/v2/wrapper.vue"
export default component.exports